import { ArrowDown, Check } from "lucide-react";
import BookButton from "@/components/np/BookButton";
import { doctor, site } from "@/content";

const FACTS = [site.noReferral, "Nybesök cirka 60 minuter", "Nacka Forum & Göteborg"];

export default function Hero() {
  return (
    <section className="hero relative overflow-hidden bg-forest text-cream" aria-labelledby="hero-title">
      <div className="container-np relative grid items-center gap-12 py-16 sm:py-20 lg:grid-cols-12 lg:gap-10 lg:py-28">
        <div className="lg:col-span-7">
          <p className="eyebrow hero-in text-amber">{site.name}</p>
          <h1 id="hero-title" className="hero-in mt-5 font-serif text-[2.6rem] leading-[1.02] text-cream sm:text-6xl lg:text-7xl" style={{ animationDelay: "60ms" }} data-testid="hero-title">
            Läkarledd behandling av <em className="font-normal italic text-sage">långvarig smärta</em>
          </h1>
          <p className="hero-in mt-6 max-w-xl text-base leading-relaxed text-cream/80 sm:text-lg" style={{ animationDelay: "120ms" }}>
            Hos Dr Hivar Kaftan, legitimerad läkare med inriktning smärtbehandling, börjar allt med en grundlig bedömning och en individuell plan. Vi arbetar med proloterapi, nervproloterapi, PRP och MLS-laser.
          </p>
          <div className="hero-in mt-9 flex flex-col gap-3 sm:flex-row" style={{ animationDelay: "180ms" }}>
            <BookButton testId="hero-book-button" size="lg" />
            <a href="#var-har-du-ont" data-testid="hero-body-link" className="inline-flex h-14 items-center justify-center gap-2 rounded-full px-7 font-semibold text-cream ring-1 ring-cream/30 transition-colors hover:bg-cream/10">
              Var har du ont? <ArrowDown className="h-4 w-4" aria-hidden="true" />
            </a>
          </div>
          <ul className="hero-in mt-10 flex flex-wrap gap-x-6 gap-y-2 text-sm text-cream/75" style={{ animationDelay: "240ms" }}>
            {FACTS.map((f) => (
              <li key={f} className="inline-flex items-center gap-2"><Check className="h-4 w-4 text-amber" aria-hidden="true" />{f}</li>
            ))}
          </ul>
        </div>
        <div className="relative mx-auto w-full max-w-[420px] lg:col-span-5">
          <div className="arch relative overflow-hidden bg-pine">
            <img src={doctor.photo} alt={doctor.photoAlt} width="1024" height="910" fetchPriority="high" className="h-full w-full object-cover object-[50%_30%]" />
          </div>
          <div className="absolute -bottom-5 left-4 right-4 rounded-2xl bg-cream px-5 py-4 text-ink shadow-xl sm:left-auto sm:right-[-12px] sm:max-w-[270px]">
            <p className="font-serif text-xl leading-tight">{doctor.name}</p>
            <p className="mt-1 text-xs text-muted">{doctor.title}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
